/**
 * Created by Ning Jiang on 10/12/2018.
 */

import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {CountDownTimer} from "@nolimitcity/slot-game/bin/core/component/CountDownTimer";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {TimelineLite, TweenLite} from "gsap";
import {TombstoneStrings} from "../../TombstoneStrings";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";

export class TombstoneFreespinOutroView extends ScreenView {

    private _youWonStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "66px",
        fontWeight : FontWeight.BOLD,
        fill : "#fff2a7",
        stroke : "#3d0025",
        strokeThickness : 5,
    };

    private _spinsPlayedStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "35px",
        fontWeight : FontWeight.BOLD,
        fill : "#fff2a7",
        stroke : "#3d0025",
        strokeThickness : 5,
    };

    private _container:PIXI.Container;
    private _darkOverlay:PIXI.Graphics;
    private _rays:TimelineSprite;
    private _noWin:PIXI.Sprite;
    private _youWinText:PIXI.Text;
    private _winAmonut:BitmapCountUp;
    private _spinsPlayed:PIXI.Text;

    private _playSoundCallback:() => void;

    constructor(config:IScreenViewConfig, autoClose:boolean = false) {
        super(config, true);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const container:PIXI.Container = new PIXI.Container();

        this._darkOverlay = new PIXI.Graphics;
        container.addChild(this._darkOverlay);

        this._rays = new TimelineSprite(GameResources.getTextures("bigWinRays"));
        this._rays.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._rays.anchor.set(0.5);
        this._rays.scale.set(2);
        container.addChild(this._rays);

        this._noWin = new PIXI.Sprite(GameResources.getTextures("badLuck")[0]);
        this._noWin.anchor.set(0.5);
        this._noWin.position.set(0, -65);
        container.addChild(this._noWin);

        this._youWinText = new PIXI.Text(` ${Translation.translate(TombstoneStrings.FS_YOU_WON_TEXT)} `, this._youWonStyle);
        this._youWinText.anchor.set(0.5);
        this._youWinText.position.set(0, -198);
        container.addChild(this._youWinText);

        this._winAmonut = new BitmapCountUp(
            {
                style : {
                    font : {name : "NumbersTombstone", size : 38},
                    tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
                }
            });
        this._winAmonut.shrinkSize = true;
        this._winAmonut.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._winAmonut.position.set(0, -52);
        container.addChild(this._winAmonut);

        this._spinsPlayed = new PIXI.Text("", this._spinsPlayedStyle);
        this._spinsPlayed.anchor.set(0.5);
        container.addChild(this._spinsPlayed);

        this.reset();

        this._container = container;
        return container;
    }

    protected createButton():NineSliceButton {
        const button:NineSliceButton = super.createButton();
        button.visible = false;
        return button;
    }

    protected createAutoCloseTimer():CountDownTimer {
        const countDown:CountDownTimer = super.createAutoCloseTimer();
        countDown.visible = false;
        return countDown;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._darkOverlay.clear();
        this._darkOverlay.beginFill(0x000000, 0.8);
        this._darkOverlay.drawRect(-this._screenWidth / 2, -this._screenHeight / 2, this._screenWidth, this._screenHeight);
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => {
            TombstoneGameModuleConfig.TBBWController.hideCountUp();
        });
        timeline.add(TweenLite.fromTo(this._container, 0.1, {alpha : 0}, {alpha : 1}));
        if(data!.totalWin > 0) {
            timeline.add(TweenLite.fromTo(this._rays.scale, 0.6,
                {x : 1, y : 1},
                {
                    x : 1.5, y : 1.5, onStart : () => {
                        this._rays.visible = true;
                        this._rays.playLoop();
                    }
                }), 0);
            timeline.add(TweenLite.fromTo(this._youWinText, 0.3,
                {alpha : 0},
                {alpha : 1, onStart : () => {
                        if(!TombstoneGameModuleConfig.gameData.isWinBelowStake()) {
                            this._youWinText.visible = true;
                        }
                }}), 0);
            timeline.add([
                TweenLite.fromTo(this._winAmonut, 0.55,
                    {alpha : 0},
                    {alpha : 1, onStart : () => this._winAmonut.visible = true}),
                this._winAmonut.getCountUpAnimation(data!.totalWin, data!.totalWin, {duration : 0})
            ], 0);
            timeline.add(() => this.playSound(), 0);

            this._spinsPlayed.position.set(0, 74);
        } else {
            timeline.add(TweenLite.fromTo(this._noWin, 0.5,
                {alpha : 0},
                {alpha : 1, onStart : () => this._noWin.visible = true}), 0);
            timeline.add(() => this.playSound(), 0);
            this._spinsPlayed.position.set(0, 174);
        }
        this._spinsPlayed.text = ` ${Translation.translate(TombstoneStrings.FS_SPINS_PLAYED)} ${(<ParsedGameData>data).numberOfFreespinsPlayed!.toString()} `;
        timeline.add(TweenLite.fromTo(this._spinsPlayed, 0.2,
            {alpha : 0},
            {alpha : 1, onStart : () => {
                this._spinsPlayed.visible = true;
            }}));
        timeline.add(() => {
            this._button.visible = true;
            // this._autoCloseTimer.visible = true;
            if(onShowComplete) {
                onShowComplete();
            }
        });
    }

    protected stopPresentation(closeCallback?:() => void):void {
        this.reset();
        this._button.visible = false;
        // this._autoCloseTimer.visible = false;

        super.stopPresentation(closeCallback);
    }

    private reset():void {
        this._rays.stopLoop();
        this._rays.visible = false;
        this._noWin.visible = false;
        this._youWinText.visible = false;
        this._winAmonut.visible = false;
        this._spinsPlayed.visible = false;
    }

    public getPlaySoundCallback(playSoundCallback:() => void):void {
        this._playSoundCallback = playSoundCallback;
    }

    private playSound():void {
        if(this._playSoundCallback) {
            this._playSoundCallback();
        }
    }
}